import Vue from 'vue';
import VueRouter from 'vue-router';

import Overview from "./views/Overview";
import Archive from "./views/Archive";
import Login from "./views/Login";
import Register from "./views/Register";
import Activate from "./views/Activate";
import ForgotPassword from "./views/ForgotPassword";
import ResetPassword from "./views/ResetPassword";
import Settings from "./views/Settings";
import AddTask from "./views/AddTask";
import EditTask from "./views/EditTask";
import DetailTask from "./views/DetailTask";

import { auth } from "./schmucklicloud";
import { Notifications } from "./notification";

Vue.use(VueRouter);

const router = new VueRouter({
    //mode: "history",
    routes: [
        {
            path: '*',
            redirect: '/'
        },
        {
            path: '/',
            name: 'Overview',
            component: Overview,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/archive',
            name: 'Archive',
            component: Archive,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: "/login",
            name: "Login",
            component: Login,
            meta: {
                requiresAuth: false,
                redirectIfAuth: true
            }
        },
        {
            path: "/register",
            name: "Register",
            component: Register,
            meta: {
                requiresAuth: false,
                redirectIfAuth: true
            }
        },
        {
            path: "/activate",
            name: "Activate",
            component: Activate,
            meta: {
                requiresAuth: false,
                redirectIfAuth: true
            }
        },
        {
            path: "/forgot",
            name: "ForgotPassword",
            component: ForgotPassword,
            meta: {
                requiresAuth: false,
                redirectIfAuth: true
            }
        },
        {
            path: "/reset",
            name: "ResetPassword",
            component: ResetPassword,
            meta: {
                requiresAuth: false,
                redirectIfAuth: true
            }
        },
        {
            path: "/settings",
            name: "Settings",
            component: Settings,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: "/task/:id",
            name: "DetailTask",
            component: DetailTask,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: "/task/:id/edit",
            name: "EditTask",
            component: EditTask,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: "/add_task",
            name: "AddTask",
            component: AddTask,
            meta: {
                requiresAuth: true
            }
        }
    ]
});

router.beforeEach(async (to, from, next) => {
    var token = localStorage.getItem("session_token");
    var response = await auth.checkSession(token);

    var isLoggedIn = response.isOK;
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
    const redirectIfAuth = to.matched.some(record => record.meta.redirectIfAuth);
  
    if (requiresAuth && !isLoggedIn) {
      Notifications.show("You are not signed in.");
      next('/login')
    }
    else if (isLoggedIn && redirectIfAuth) next('/dashboard');
    else next();
  });

export default router;